module.exports = __webpack_public_path__ + "img/27_17.0a33f515.png";